import { useState } from 'react'

import { type EIcons } from '@/app/types/iconType'
import { Button, Icon } from '@/shared'
import { type IPriceDto, type IFedOrderDto } from '@App/types/adminsTypes'
import { DEFAULT_LINKS } from '@Config/config'

import style from './Actions.module.scss'
import { EditDocModal } from './EditDocModal/EditDocModal'
import { UpdateOrderModal } from './UpdateOrderModal/UpdateOrderModal'
import { UpdatePriceModal } from './UpdatePriceModal/UpdatePriceModal'

interface IAction {
    title: string
    icon: EIcons | null
    callback: () => void
}

interface IProps {
    showUpdatePriceModal: boolean
    showUpdateOrderModal: boolean
    activateDates: string[] | null
    isFetchingAdmins: boolean
    onUploadFileCallback: (dto: IPriceDto) => void
    onUploadOrderFileCallback: (dto: IFedOrderDto) => void
    setShowUpdatePriceModal: (showUpdatePriceModal: boolean) => void
    setShowUpdateOrderModal: (showUpdateOrderModal: boolean) => void
    onGetPriceActivateDates: () => void
    onGetPriceDataByDate: (date: string) => void
    onChangeDocument: (file: Blob, fileName: string, onSuccess: () => void) => void
}

export const Actions = (props: IProps) => {
    const {
        activateDates,
        showUpdatePriceModal,
        showUpdateOrderModal,
        isFetchingAdmins,
        onUploadFileCallback,
        onUploadOrderFileCallback,
        setShowUpdatePriceModal,
        setShowUpdateOrderModal,
        onGetPriceActivateDates,
        onGetPriceDataByDate,
        onChangeDocument
    } = props

    const { offer, policy } = DEFAULT_LINKS

    const onOpenUpdatePriceModal = () => {
        onGetPriceActivateDates()
        setShowUpdatePriceModal(true)
    }
    const onOpenUpdateOrderModal = () => {
        // onGetPriceActivateDates()
        setShowUpdateOrderModal(true)
    }
    const onCloseUpdatePriceModal = () => setShowUpdatePriceModal(false)
    const onCloseUpdateOrderModal = () => setShowUpdateOrderModal(false)

    const [editable, setEditable] = useState<string | null>(null)

    const actions: IAction[] = [
        { title: 'Обновить оферту', callback: () => setEditable(offer), icon: null },
        // { title: 'Обновить доверенность', callback: () => setEditable(attorney), icon: null },
        { title: 'Обновить политику обработки', callback: () => setEditable(policy), icon: null },
        { title: 'Обновить приказ', callback: onOpenUpdateOrderModal, icon: null },
        { title: 'Обновить прайс', callback: onOpenUpdatePriceModal, icon: null }
        // { title: 'Добавить админа', callback: () => setShowAddAdmin(true), icon: EIcons.PLUS }
    ]

    return (
        <div className={style.container}>
            {editable && (
                <EditDocModal
                    editable={editable}
                    onClose={() => setEditable(null)}
                    onChangeDocument={onChangeDocument}
                />
            )}
            {showUpdatePriceModal && (
                <UpdatePriceModal
                    show={showUpdatePriceModal && !!activateDates}
                    isFetching={isFetchingAdmins}
                    activateDates={activateDates}
                    onClose={onCloseUpdatePriceModal}
                    onUploadFileCallback={onUploadFileCallback}
                    onGetPriceDataByDate={onGetPriceDataByDate}
                />
            )}
            {showUpdateOrderModal && (
                <UpdateOrderModal
                    show={showUpdateOrderModal}
                    onClose={onCloseUpdateOrderModal}
                    onUploadFileCallback={onUploadOrderFileCallback}
                />
            )}
            {actions.map((action) => {
                const { title, callback, icon } = action
                return (
                    <Button key={title} onClick={callback} disabled={isFetchingAdmins}>
                        <div>
                            {icon && <Icon iconName={icon} color='#fff' />}
                            <span>{title}</span>
                        </div>
                    </Button>
                )
            })}
        </div>
    )
}
